import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import DropzoneComponent from 'react-dropzone-component';
import config from 'config';
import { getAuthToken } from 'api';

class FileUploader extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
  	var simpleCallback = (e) => {
  		debugger
  	}

    const eventHandlers = {
      init: dz => this.dropzone = dz,
      // drop: this.callbackArray,
      // addedfile: this.callback,
      success: this.props.onSuccess,
      error : this.props.onError,
      complete : this.props.onComplete,
      // addedFile: simpleCallback,
      // removedfile: this.removedfile
      ...(this.props.eventHandlers || {})
    }

    const djsConfig = {
      addRemoveLinks: this.props.addRemoveLinks,
      acceptedFiles: this.props.acceptedFiles,
      headers: { 'token': getAuthToken() },
      ...(this.props.config || {})
    }

    const dzConfig = {
      iconFiletypes: this.props.iconFiletypes || this.props.iconFileTypes || ['.jpg', '.png', '.gif', '.pdf'],
      showFiletypeIcon: true,
      postUrl: `${config.url}${this.props.endpoint}`
    }

    return (
      <div className="upload-wrapper">
        <DropzoneComponent config={dzConfig} eventHandlers={eventHandlers} djsConfig={djsConfig} />
      </div>
    );
  }
}

FileUploader.propTypes = {
  endpoint : PropTypes.string,
  addRemoveLinks: PropTypes.string,
  acceptedFiles: PropTypes.string,
  maxFiles : PropTypes.number,
  onSuccess : PropTypes.func,
  config : PropTypes.object,
  eventHandlers : PropTypes.object,
}


export default FileUploader



// WEBPACK FOOTER //
// ./src/browser/components/ui/fileUploader.js